import { jsx, jsxs } from 'react/jsx-runtime';
import { useSiteContext, isBitiba } from '@zooplus/commons-lang';
import { LayoutContainer, Anchor } from '@zooplus/ui-components';
import { useContext } from 'react';
import PageWidthContext from '../../contexts/PageWidthContext.js';
import styles from './LegalLinks.module.scss.js';

const LegalLinks = ({ legalLinks }) => {
    const { site } = useSiteContext();
    const pageWidth = useContext(PageWidthContext);
    return (jsx("section", { className: styles.legalLinks, children: jsxs(LayoutContainer, { className: styles.legalLinksWrapper, variant: pageWidth, children: [jsx("ul", { className: styles.linkList, children: legalLinks.map((item, index) => (jsx("li", { children: jsx(Anchor, { variant: "grey", href: item.targetLink, children: item.linkText }) }, index))) }), jsxs("span", { className: styles.copyright, children: [isBitiba(site.domain) ? 'bitiba GmbH' : '© zooplus SE', " ", new Date().getFullYear()] })] }) }));
};

export { LegalLinks as default };
//# sourceMappingURL=LegalLinks.js.map
